import _ from "lodash";
import { createContext, useContext, useEffect, useState } from "react";

const StandardParagraphFilterContext = createContext();

export const useStandardParagraphFilterContext = () => useContext(StandardParagraphFilterContext);

export const StandardParagraphDefaultFilters = {
    typeIds: [],
    minCreatedDate: null,
    maxCreatedDate: null,
    createdByIds: [],
    minPublishedDate: null,
    maxPublishedDate: null,
    publishedByIds: [],
    statuses: []
};

const filterStore = "filters.standard-paragraphs"

export const StandardParagraphFilterProvider = ({
    children
}) => {
    const [showFilterModal, setShowFilterModal] = useState(false);

    const [filter, setFilter] = useState(StandardParagraphDefaultFilters);
    const [tempFilter, setTempFilter] = useState(filter);
    const [isReady, setIsReady] = useState(false);

    const isFiltersApplied = !_.isEqual(StandardParagraphDefaultFilters, filter);

    // Reset means clear any temp filter and apply
    const resetFilter = () => {
        setTempFilter(StandardParagraphDefaultFilters);
        setFilter(StandardParagraphDefaultFilters);
        sessionStorage.removeItem(filterStore);
    };

    // Clear means remove currently selected filters and return to previous
    const clearFilter = () => setTempFilter(filter);

    const updateFilter = (filterProperty, newValue) => setTempFilter((prev) => ({
        ...prev,
        [filterProperty]: newValue
    }));

    const applyFilter = () => setFilter(tempFilter);

    // Update filter on first load to retrieve from session storage
    useEffect(() => {
        let filterString = sessionStorage.getItem(filterStore);
        let filterObj = JSON.parse(filterString);

        if (filterObj != null)
            setFilter(filterObj);

        setIsReady(true);
    }, []);

    // Update session storage when filter updated
    useEffect(() => {
        if (!isFiltersApplied)
            return;

        sessionStorage.setItem(filterStore, JSON.stringify(filter));
    }, [filter]);

    return <StandardParagraphFilterContext.Provider value={{
        showFilterModal,
        setShowFilterModal,
        isFiltersApplied,
        isReady,
        filter,
        tempFilter,
        resetFilter,
        clearFilter,
        updateFilter,
        applyFilter
    }}>
        {children}
    </StandardParagraphFilterContext.Provider>
}